import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Trash2, Plus, Eye, EyeOff } from "lucide-react";
import { api } from "@/lib/api";

const input = "w-full rounded-lg border border-[#2C2C2C]/20 bg-white px-3 py-2 text-sm outline-none focus:border-[#C9A84C]";
const EMPTY = { author: "", text: "", source: "Google", rating: 5, published: true, order: 0 };

export default function AdminTemoignages() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);

  const load = useCallback(() => { api.get("/testimonials", { params: { include_hidden: true } }).then((r) => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!form.author.trim() || !form.text.trim()) { toast.error("Auteur et texte requis"); return; }
    try { await api.post("/testimonials", { ...form, rating: Number(form.rating), order: items.length }); setForm(EMPTY); toast.success("Témoignage ajouté"); load(); }
    catch { toast.error("Échec"); }
  };
  const update = async (it, patch) => { try { await api.put(`/testimonials/${it.id}`, { ...it, ...patch }); load(); } catch { toast.error("Échec"); } };
  const remove = async (id) => { if (!window.confirm("Supprimer ?")) return; try { await api.delete(`/testimonials/${id}`); load(); } catch { toast.error("Échec"); } };

  return (
    <div data-testid="admin-temoignages">
      <h1 className="font-serif text-3xl text-[#2C2C2C]">Témoignages</h1>
      <p className="mt-1 text-sm text-[#2C2C2C]/60">Ajoutez uniquement de vrais avis (Google, Mariages.net…). Indiquez la source. N'inventez jamais de témoignage.</p>

      <div className="mt-6 rounded-xl border border-[#2C2C2C]/10 bg-white p-6">
        <div className="grid gap-3 sm:grid-cols-2">
          <input className={input} placeholder="Auteur" data-testid="testimonial-author" value={form.author} onChange={(e) => setForm({ ...form, author: e.target.value })} />
          <select className={input} data-testid="testimonial-source" value={form.source} onChange={(e) => setForm({ ...form, source: e.target.value })}>
            <option>Google</option><option>Mariages.net</option><option>Autre</option>
          </select>
        </div>
        <textarea className={`${input} mt-3`} rows={3} placeholder="Texte de l'avis (authentique)" data-testid="testimonial-text" value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} />
        <div className="mt-3 flex items-center gap-3">
          <label className="text-sm text-[#2C2C2C]/70">Note :</label>
          <select className={`${input} w-24`} value={form.rating} onChange={(e) => setForm({ ...form, rating: e.target.value })}>
            {[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{n} ★</option>)}
          </select>
        </div>
        <button onClick={add} data-testid="testimonial-add" className="mt-4 flex items-center gap-2 rounded-lg bg-[#2C2C2C] px-5 py-2.5 text-sm text-white hover:bg-[#C9A84C] hover:text-[#2C2C2C]"><Plus size={15} /> Ajouter</button>
      </div>

      <div className="mt-6 space-y-3">
        {items.length === 0 && <p className="text-[#2C2C2C]/50" data-testid="testimonials-empty">Aucun témoignage.</p>}
        {items.map((t) => (
          <div key={t.id} className="flex items-start justify-between gap-4 rounded-xl border border-[#2C2C2C]/10 bg-white p-4" data-testid={`testimonial-item-${t.id}`}>
            <div>
              <p className="text-sm text-[#2C2C2C]/80">“{t.text}”</p>
              <p className="mt-1 text-xs text-[#2C2C2C]/50">{t.author} — {t.source} {t.rating ? `· ${t.rating}★` : ""}</p>
            </div>
            <div className="flex shrink-0 gap-2">
              <button onClick={() => update(t, { published: !t.published })} className="text-[#2C2C2C]/70">{t.published ? <Eye size={16} /> : <EyeOff size={16} />}</button>
              <button onClick={() => remove(t.id)} className="text-red-600"><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
